module.exports = __webpack_public_path__ + "static/lonehill-X41-deb1f849a52c778645ce38e25e0a2b98.jpg";